var _path;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgIcMore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 20,
    viewBox: "0 0 5 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.39941 0C2.92985 0 3.43855 0.210714 3.81363 0.585786C4.1887 0.960859 4.39941 1.46957 4.39941 2C4.39941 2.53043 4.1887 3.03914 3.81363 3.41421C3.43855 3.78929 2.92985 4 2.39941 4C1.86898 4 1.36027 3.78929 0.985201 3.41421C0.610128 3.03914 0.399414 2.53043 0.399414 2C0.399414 1.46957 0.610128 0.960859 0.985201 0.585786C1.36027 0.210714 1.86898 0 2.39941 0ZM2.39941 8C2.92985 8 3.43855 8.21071 3.81363 8.58579C4.1887 8.96086 4.39941 9.46957 4.39941 10C4.39941 10.5304 4.1887 11.0391 3.81363 11.4142C3.43855 11.7893 2.92985 12 2.39941 12C1.86898 12 1.36027 11.7893 0.985201 11.4142C0.610128 11.0391 0.399414 10.5304 0.399414 10C0.399414 9.46957 0.610128 8.96086 0.985201 8.58579C1.36027 8.21071 1.86898 8 2.39941 8ZM2.39941 16C2.92985 16 3.43855 16.2107 3.81363 16.5858C4.1887 16.9609 4.39941 17.4696 4.39941 18C4.39941 18.5304 4.1887 19.0391 3.81363 19.4142C3.43855 19.7893 2.92985 20 2.39941 20C1.86898 20 1.36027 19.7893 0.985201 19.4142C0.610128 19.0391 0.399414 18.5304 0.399414 18C0.399414 17.4696 0.610128 16.9609 0.985201 16.5858C1.36027 16.2107 1.86898 16 2.39941 16Z",
    fill: "#737373"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMore);
export default __webpack_public_path__ + "static/media/ic-more.24bddd0ceb1e9889828297384bc6fcae.svg";
export { ForwardRef as ReactComponent };